import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useInView } from '../../../hooks/useInView';

const ServicesSection = () => {
  const { ref, isInView } = useInView({ threshold: 0.2 });

  const services = [
    {
      title: 'SES事業',
      description: `信頼できる人材を、必要な場所へ。共創型SESで、お客様のプロジェクトを成功に導きます。`,
      icon: 'ri-team-line',
      bg: 'bg-sage',
      textColor: 'text-white',
    },
    {
      title: 'ITコンサルティング／PMO支援事業',
      description: '会社・SIerの変革を、構想から実行まで伴走支援。戦略立案から実装まで、一貫したサポートを提供します。',
      icon: 'ri-lightbulb-line',
      bg: 'bg-mustard',
      textColor: 'text-white',
    },
    {
      title: 'アプリ開発事業',
      description: '企画から開発、運用までの一貫したアプリケーション開発サービス。お客様のビジョンを形にします。',
      icon: 'ri-code-s-slash-line',
      bg: 'bg-darkgray',
      textColor: 'text-white',
    },
  ];

  return (
    <section ref={ref} className="bg-white py-16 lg:py-24">
      <div className="px-8 lg:px-16 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <motion.span
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="text-base tracking-wider text-warmgray font-sans"
          >
            Services
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="font-serif text-4xl lg:text-5xl text-darkgray mt-4 mb-4"
          >
            事業内容
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="font-sans text-lg text-gray-600"
          >
            3つの事業で、ITと現場をつなぐ
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.2 + index * 0.1 }}
              className={`${service.bg} ${service.textColor} rounded p-6 lg:p-8 flex flex-col justify-between min-h-[300px] group cursor-pointer transition-all duration-500 hover:shadow-lg`}
            >
              <div className="text-center">
                <div className="w-14 h-14 flex items-center justify-center mb-5 mx-auto">
                  <i className={`${service.icon} text-4xl`}></i>
                </div>
                <h3 className="font-sans text-xl font-medium mb-4">
                  {service.title}
                </h3>
                <p className="font-sans text-base leading-relaxed opacity-90">
                  {service.description}
                </p>
              </div>
              <div className="mt-6 text-center">
                <Link
                  to="/services"
                  className="inline-flex items-center gap-2 text-base font-sans tracking-wide transition-all duration-300 group-hover:gap-3"
                >
                  詳しく見る
                  <i className="ri-arrow-right-line text-lg"></i>
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;